module.exports = __webpack_public_path__ + "src/assets/images/product-icons/icon-altenergy.png?e59b9e4b2f16f431d64c2f187196e04d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-icons/icon-altenergy.png
// module id = 1024
// module chunks = 1